import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Briefcase, FileText, Users, LogOut, ExternalLink, Tag, Building2, ClipboardList, MessageSquare, MapPin } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function AdminLayout() {
  const { admin, logoutAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutAdmin();
    navigate('/admin/login');
  };

  if (!admin) {
    navigate('/admin/login');
    return null;
  }

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          <img src="/logo.png" alt="CareerQuess Logo" className="admin-logo" />
          <span>Admin Panel</span>
        </div>
        <nav className="admin-nav">
          <NavLink to="/admin" end><LayoutDashboard size={20} /> Dashboard</NavLink>
          <NavLink to="/admin/jobs"><Briefcase size={20} /> Jobs</NavLink>
          <NavLink to="/admin/categories"><Tag size={20} /> Categories</NavLink>
          <NavLink to="/admin/locations"><MapPin size={20} /> Locations</NavLink>
          <NavLink to="/admin/employers"><Building2 size={20} /> Employers</NavLink>
          <NavLink to="/admin/applications"><FileText size={20} /> Applications</NavLink>
          <NavLink to="/admin/resumes"><Users size={20} /> Resumes</NavLink>
          <NavLink to="/admin/requirements"><ClipboardList size={20} /> Emp. Requirements</NavLink>
          <NavLink to="/admin/enquiries"><MessageSquare size={20} /> Industry Enquiries</NavLink>
          <a href="/" target="_blank" rel="noreferrer"><ExternalLink size={20} /> View Site</a>
        </nav>
      </aside>
      <main className="admin-main">
        <div className="admin-header">
          <h1>Welcome, {admin.name}</h1>
          <button className="btn-logout" onClick={handleLogout}><LogOut size={16} /> Logout</button>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
